import { render, staticRenderFns } from "./china-case.vue?vue&type=template&id=1fdeb036&scoped=true&"
import script from "./china-case.vue?vue&type=script&lang=js&"
export * from "./china-case.vue?vue&type=script&lang=js&"
import style0 from "./china-case.vue?vue&type=style&index=0&id=1fdeb036&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdeb036",
  null
  
)

export default component.exports